import { getGlobalFeatureValue } from './growthbook';

const DEFAULT_PUBLIC_PATHS = [
  'marketplace/config',
  'category/categories/favourite',
  'provider/providers',
  'games',
  'events/published/grouped',
  'events/published/grouped/featured-tournaments',
];

const normalizePath = (path: string) => path.replace(/^\/+/, '').split('?')[0]?.split('#')[0] ?? '';

const buildRegexPatterns = (paths: string[]) =>
  paths.map((path) => {
    const regexString = normalizePath(path).replace(/:\w+/g, '[a-zA-Z0-9-_]+');
    return new RegExp(`^${regexString}$`);
  });

const DEFAULT_PUBLIC_PATTERNS: RegExp[] = buildRegexPatterns(DEFAULT_PUBLIC_PATHS);

const getPublicPatterns = (publicEndpoints: string[] | null) => {
  if (!publicEndpoints?.length) {
    return DEFAULT_PUBLIC_PATTERNS;
  }

  const mergedPublicEndpoints = [...new Set([...DEFAULT_PUBLIC_PATHS, ...publicEndpoints].map(normalizePath))];

  return buildRegexPatterns(mergedPublicEndpoints);
};

export const isRequestPublic = (path: string) => {
  const publicEndpoints = getGlobalFeatureValue<string[]>('public-paths', null);
  const regexPatterns = getPublicPatterns(publicEndpoints);

  return regexPatterns.some((pattern) => pattern.test(normalizePath(path)));
};
